(function () {
  if (window.ThemeQuickView) return;

  const initializedDialogs = new WeakSet();

  const closeDialog = (dialog) => {
    if (!dialog) return;

    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
      return;
    }

    dialog.removeAttribute('open');
  };

  const updateVariant = (dialog, option) => {
    if (!dialog || !option) return;

    const variantSelect = dialog.querySelector('[data-qv-variant-select]');
    const price = dialog.querySelector('[data-qv-price]');
    const stock = dialog.querySelector('[data-qv-stock]');
    const stockWrap = dialog.querySelector('.quick-view__stock');
    const addButton = dialog.querySelector('[data-qv-add]');
    const selection = dialog.querySelector('[data-qv-selection]');

    if (variantSelect) {
      variantSelect.value = option.value;
    }

    if (price) {
      price.textContent = option.dataset.price || '';
    }

    const available = option.dataset.available === 'true';
    const inventory = Number(option.dataset.inventory || 0);

    if (stock) {
      if (available && inventory > 0) {
        stock.textContent = `${inventory} ${dialog.dataset.inStockLabel}`;
      } else {
        stock.textContent = available ? dialog.dataset.inStockLabel : dialog.dataset.outOfStockLabel;
      }
    }

    if (stockWrap) {
      stockWrap.classList.toggle('is-unavailable', !available);
    }

    if (addButton) {
      addButton.disabled = !available;
      addButton.textContent = available ? addButton.dataset.availableLabel : addButton.dataset.soldOutLabel;
    }

    if (selection) {
      selection.textContent = option.textContent.trim();
    }
  };

  const selectedOptionValues = (dialog) =>
    Array.from(dialog.querySelectorAll('[data-qv-option-index]')).map((optionGroup) => {
      const selected = optionGroup.querySelector('[data-qv-option-value][aria-pressed="true"]');
      return selected ? selected.dataset.qvOptionValue : '';
    });

  const findMatchingVariant = (variantSelect, values) =>
    Array.from(variantSelect.options).find((option) => {
      const optionValues = option.dataset.options ? option.dataset.options.split('||') : [];
      return optionValues.length === values.length && optionValues.every((value, index) => value === values[index]);
    });

  const initializeDialog = (dialog) => {
    if (!dialog || initializedDialogs.has(dialog)) return;
    initializedDialogs.add(dialog);

    const variantSelect = dialog.querySelector('[data-qv-variant-select]');

    if (variantSelect) {
      updateVariant(dialog, variantSelect.selectedOptions[0]);
    }
  };

  const openDialog = (button) => {
    const dialog = document.getElementById(button.getAttribute('aria-controls'));
    if (!dialog) return;

    initializeDialog(dialog);

    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) {
        dialog.showModal();
      }
      return;
    }

    dialog.setAttribute('open', '');
  };

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-quick-view-open]');

    if (openButton) {
      event.preventDefault();
      openDialog(openButton);
      return;
    }

    const closeButton = event.target.closest('[data-quick-view-close]');

    if (closeButton) {
      event.preventDefault();
      closeDialog(closeButton.closest('[data-quick-view-dialog]'));
      return;
    }

    const thumb = event.target.closest('[data-qv-thumb]');

    if (thumb) {
      const dialog = thumb.closest('[data-quick-view-dialog]');
      const mainImage = dialog && dialog.querySelector('[data-qv-main-image]');

      if (mainImage) {
        mainImage.src = thumb.dataset.qvImageSrc;
        mainImage.alt = thumb.dataset.qvImageAlt || '';
      }

      if (dialog) {
        dialog.querySelectorAll('[data-qv-thumb]').forEach((thumbButton) => {
          const isCurrent = thumbButton === thumb;
          thumbButton.classList.toggle('is-active', isCurrent);
          thumbButton.setAttribute('aria-selected', String(isCurrent));
        });
      }

      return;
    }

    const optionButton = event.target.closest('[data-qv-option-value]');

    if (optionButton) {
      const dialog = optionButton.closest('[data-quick-view-dialog]');
      const group = optionButton.closest('[data-qv-option-index]');
      const variantSelect = dialog && dialog.querySelector('[data-qv-variant-select]');

      if (group) {
        group.querySelectorAll('[data-qv-option-value]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button === optionButton));
        });
      }

      if (dialog && variantSelect) {
        updateVariant(dialog, findMatchingVariant(variantSelect, selectedOptionValues(dialog)));
      }

      return;
    }

    const quantityButton = event.target.closest('[data-qv-quantity-step]');

    if (quantityButton) {
      const dialog = quantityButton.closest('[data-quick-view-dialog]');
      const input = dialog && dialog.querySelector('[data-qv-quantity]');
      const step = Number(quantityButton.dataset.qvQuantityStep);
      const current = Number((input && input.value) || 1);

      if (input) {
        input.value = Math.max(1, current + step);
      }

      return;
    }

    const tab = event.target.closest('[data-qv-tab]');

    if (tab) {
      const dialog = tab.closest('[data-quick-view-dialog]');
      const target = tab.dataset.qvTab;

      if (dialog) {
        dialog.querySelectorAll('[data-qv-tab]').forEach((button) => {
          const isCurrent = button === tab;
          button.classList.toggle('is-active', isCurrent);
          button.setAttribute('aria-selected', String(isCurrent));
        });

        dialog.querySelectorAll('[data-qv-tab-panel]').forEach((panel) => {
          const isCurrent = panel.dataset.qvTabPanel === target;
          panel.hidden = !isCurrent;
          panel.classList.toggle('is-active', isCurrent);
        });
      }

      return;
    }

    if (event.target.matches('[data-quick-view-dialog]')) {
      closeDialog(event.target);
    }
  });

  document.addEventListener('change', (event) => {
    const variantSelect = event.target.closest('[data-qv-variant-select]');

    if (!variantSelect) return;

    updateVariant(variantSelect.closest('[data-quick-view-dialog]'), variantSelect.selectedOptions[0]);
  });

  window.ThemeQuickView = {
    open: openDialog,
    close: closeDialog,
  };
})();
